const getActiveVoucherCodes = (vouchers)=>{
    if (!vouchers) {
        return;
    }
    return vouchers.filter((voucher)=>voucher.isActive
    ).map((voucher)=>voucher.code
    );
};
const getActiveVoucherNames = (vouchers)=>{
    if (!vouchers) {
        return;
    }
    return vouchers.filter((voucher)=>voucher.isActive
    ).map((voucher)=>voucher.name
    );
};

export { getActiveVoucherCodes, getActiveVoucherNames };
//# sourceMappingURL=get-active-voucher-codes.js.map
